import { TripGrouping } from '../../lib/types/models/trip-grouping/trip-grouping'
import { AssignTripsToTripGroupingInput } from '../../lib/types/models/trip-grouping/trip-grouping-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function assignTripsToTripGrouping(
  input: AssignTripsToTripGroupingInput & { tripGroupingId: number }
) {
  const { tripGroupingId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.tripGroupings.assignTrips.url, { id: tripGroupingId }))
    .post<TripGrouping, AssignTripsToTripGroupingInput>(rest)
}
